export default __webpack_public_path__ + "static/loupe-design-system-sheets-component-detail-678ffc1f29edbe2dcffa6c1fad2fc844.png";